<template>
    <v-col>
        <v-card class="mx-auto pa-5" 
            max-width="400" outlined>
            <v-icon class="d-flex justify-center" :color="information.color" x-large>{{ information.icon }}</v-icon>
            <v-chip :color="information.color" class="d-flex my-4 py-7 justify-center" text-color="white" label>
                <v-card-title class="font-weight-bold" >{{ getPlanName() }}</v-card-title>
            </v-chip>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="d-flex justify-center">
                        <span class="title font-weight-bold">{{ information.currency }}</span>
                        <span class="display-3 font-weight-bold">{{ information.price }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="d-flex justify-center">
                        <span class="subheading">{{ getPeriodicity() }}</span>
                        <v-divider class="mx-2 my-0" inset vertical></v-divider>
                        <span class="subheading black--text">{{ getBilled() }}</span>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <div v-if="highlighted">
                <div v-bind:key="prop.item" v-for="(prop, index) in properties">
                    <div v-if="index < rederedSize">
                        <v-list-item >
                            <v-list-item-icon>
                                <v-icon>fa-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title v-html="prop.item"></v-list-item-title>
                        </v-list-item>
                        <v-divider class="mx-4"></v-divider>
                    </div>
                </div>
            </div>
            <div v-if="rederedSize !== properties.length && highlighted !== false" class="d-flex mb-3 mt-7 justify-center">
                <v-btn class="my-2" @click="readMorePlanInformation" plain> {{ $t('readMore') }} </v-btn>
            </div>
            <div class="d-flex mb-3 mt-7 justify-center">
                <!--ePayco Button!-->
                <!-- <v-btn v-if="information.planName !== 'BASIC' && this.$store.state.user.details.country === 'Colombia'" :class="(information.planName.startsWith('ANNUALLY'))? 'special-button' : 'ml-0'" @click="payNow">
                    {{ $t('payWithCreditCard') }} »
                </v-btn> -->
                <!-- Paypal Button!-->
                <div class="paypal-button-container"></div>
            </div>
        </v-card>
    </v-col>
</template>

<script>
    export default {
        name: "PlanCardCollapsed",
        props: {
            information: Object,
            properties: Array,
            highlighted: Boolean,
        },
        data() {
            return {
                rederedSize: 5,
            };
        },
        methods: {
            getPlanName(){
                if(this.information.planName==='Monthly Pro'){
                    return this.$t('monthlyPro');
                }else if(this.information.planName==='Annually Pro'){
                    return this.$t('annuallyPro');
                }else if(this.information.planName==='Lifetime Pro'){
                    return this.$t('lifetimePro');
                }else if(this.information.planName==='BASIC'){
                    return this.$t('basic');
                }
            },
            getPeriodicity(){
                if(this.information.periodicity==='Per month'){
                    return this.$t('perMonth')
                }else if(this.information.periodicity==='Forever'){
                    return this.$t('forever')
                }
            },
            getBilled(){
                if(this.information.billed==='Billed monthly'){
                    return this.$t('billedMonthly')
                }else if(this.information.billed==='Billed yearly'){
                    return this.$t('billedYearly')
                }else if(this.information.billed==='Lifetime'){
                    return this.$t('lifetime')
                }
            },
            readMorePlanInformation() {
                this.rederedSize = this.properties.length;
            }
        }
    }
</script>

<style scoped>
    .special-border-color {
        border: 2px solid #00abff !important;
    }

    .special-button {
        border: 2px solid #00abff !important;
    }

    .special-button:hover {
        border: 2px solid #00abff !important;
        background-color: #00abff !important;
        color: #ffffff !important;
    }
</style>


